
import React, { useState, useEffect } from "react";
function Countdown({timerDate}) {
  const [timer, setTimer] = useState();
  const [days, setDays] = useState();
  const [hours, setHours] = useState();
  const [minitues, setMinitues] = useState();
  const [seconds, setSeconds] = useState();

  useEffect(() => {   

    if(timerDate){
      getWaitingTime();
    }   
 
  }, [timerDate]);

 

  var inervalTime = null;

  const getWaitingTime = () => {
   if(timerDate){


    inervalTime = setInterval(function () {

      let currentDate = new Date().getTime();

      let newDate2 = new Date(timerDate).getTime();
      let dif = newDate2 - currentDate;
      // console.log(currentDate, newDate2)
      var days = Math.floor(dif / (1000 * 60 * 60 * 24));
      days = days.toString();
      days = days.padStart(2, "0")
      var hours = Math.floor((dif % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      hours = hours.toString();
      hours = hours.padStart(2, "0")
      var minutes = Math.floor((dif % (1000 * 60 * 60)) / (1000 * 60));
      minutes = minutes.toString();
      minutes = minutes.padStart(2, "0")
      var seconds = Math.floor((dif % (1000 * 60)) / 1000);
      seconds = seconds.toString();
      seconds = seconds.padStart(2, "0")
    
      let returnTimer =
        days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

      if (dif < 0) {
        clearInterval(inervalTime);   
        // console.log("returnTimer", returnTimer)     
        setTimer(null);
      } else {
        // console.log("returnTimer", returnTimer)
        setTimer(returnTimer);
        setDays(days);
        setHours(hours);
        setMinitues(minutes);
        setSeconds(seconds);
      }
    }, 1000);

 
   }
   
  };

 

    return (
      
     <>
      <label className="timer">{<><span>{days} DAYS</span> : <span>{hours} HOURS</span> : <span>{minitues} MINUTES</span> : <span>{seconds} SECONDS</span></>  }</label>     
      
     </>
     
    
    );
  }
  
  export default Countdown;
  
